import { useCallback, useEffect, useRef } from "react";
import { Duration } from "luxon";

export const useTimedFlag = ({ duration }: { duration: Duration }) => {
  const flagRef = useRef(false);
  const timeoutRef = useRef<number | null>(null);
  const durationMs = duration.toMillis();

  const activate = useCallback(() => {
    flagRef.current = true;
    if (timeoutRef.current !== null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(() => {
      flagRef.current = false;
      timeoutRef.current = null;
    }, durationMs);
  }, [durationMs]);

  const isActive = useCallback(() => flagRef.current, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { activate, isActive };
};
